import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link, useParams } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';

const Logo = ({
  at,
  width,
  className,
  textClass,
  monitoringLocationData,
  firstMonitoringCluster,
  ...rest
}) => {
  // eslint-disable-next-line no-undef
  const { cluster: clusterParam } = useParams();

  const domain = window.location.hostname;
  // const clientName = domain?.split('.')[0].toUpperCase();
  const clientName = 'FCS-DB';
  let logo;
  if (clientName == 'SESTA') {
    logo = require('../../assets/img/illustrations/sesta_logo.png');
  } else if (clientName == 'RPLC') {
    logo = require('../../assets/img/illustrations/idh_logo.png');
  } else if (clientName == 'AMBUJAFOUNDATION') {
    logo = require('../../assets/img/illustrations/ambuja_logo.png');
  } else if (clientName == 'MRV') {
    logo = require('../../assets/img/illustrations/farmsio_logo.png');
  } else if (clientName == 'FCS-DB') {
    logo = require('../../assets/img/illustrations/Seal_of_Maharashtra_bo.png');
  } else {
    logo = require('../../assets/img/illustrations/farmsio_logo.png');
  }

  let tenant;
  const tokenFromLocalStorage = localStorage.getItem('token');
  let decodedToken;
  if (tokenFromLocalStorage) {
    decodedToken = jwtDecode(tokenFromLocalStorage);
    tenant = decodedToken?.tenant_id;
  }

  return (
    <Link
      to={`/${tenant}/dashboardAnalytics}`}
      className={classNames(
        'text-decoration-none',
        { 'navbar-brand text-left': at === 'navbar-vertical' },
        { 'navbar-brand text-left': at === 'navbar-top' }
      )}
      {...rest}
    >
      <div
        className={classNames(
          'd-flex',
          'align-items-center',
          { 'dashboard-logo-container': at === 'navbar-vertical' },
          { 'align-items-center': at === 'navbar-top' },
          { 'flex-center fw-bolder fs-5 mb-4': at === 'auth' },
          className
        )}
      >
        {/* <img className="me-2" src={logo} alt="Logo" width={width} /> */}
        <span className={classNames('font-sans-serif', textClass)}>
          <img
            className="me-2 mb-2 dashboard-logo"
            src={logo}
            alt="Logo"
            style={{ width: clientName == 'FCS-DB' ? '60px' : '90px' }}
          />
        </span>
      </div>
    </Link>
  );
};

Logo.propTypes = {
  at: PropTypes.oneOf(['navbar-vertical', 'navbar-top', 'auth']),
  width: PropTypes.number,
  className: PropTypes.string,
  textClass: PropTypes.string,
  monitoringLocationData: PropTypes.arrayOf(PropTypes.object), // Add this line
  firstMonitoringCluster: PropTypes.string
};

Logo.defaultProps = { at: 'auth', width: 58 };

export default Logo;
